import React from 'react';
//import axios from 'axios';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';
//import SwitchButton from './SwitchButton';
//import { NavLink } from 'react-router-dom';
import GetAge from './GetAge';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);

export default class GetUser extends React.Component {
  state = {
    user: []
  }

  componentDidMount() {
    apiProfessional.getUser(this.props.user_id)
      //api.get(`/user/${this.props.user_id}`, { headers: { 'x-access-token': token } })
      .then(res => {
        const user = res.data;
        this.setState({ user });
      })
  }

  render() {
    return (
      <ul>
        {this.state.user.map(details =>
          <>
            <p id="RI-Title-Cadastro-Paciente" >ID do Paciente: </p><p>{details.numericID}</p>
            <p id="RI-Title-Cadastro-Paciente" >Nome do Paciente: </p><p>{details.name}</p>
            {details.user_type === "Paciente" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Paciente da instituição</p></> :
              details.user_type === "Funcionario" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Funcionário da instituição</p></> :
                null}
            <p id="RI-Title-Cadastro-Paciente" >Data de Nascimento: </p><p>{details.birth}</p>
            <p id="RI-Title-Cadastro-Paciente" >Idade do Paciente: </p><p><GetAge birth={details.birth} /> anos</p>
            <p id="RI-Title-Cadastro-Paciente" >CPF: </p><p>{details.cpf}</p>
            <p id="RI-Title-Cadastro-Paciente" >Genêro: </p><p>{details.gender}</p>

          </>)}
      </ul>
    )
  }
}